<div class="flex flex-col gap-4">
  <elcia-numeric-input
    [control]="coefficient"
    [label]="'product.coefficient' | translate"
    [min]="0.01"
    [minFractionDigits]="2"
    [maxFractionDigits]="4"
  />
  <elcia-date-picker
    [control]="startDate"
    [label]="'product.price-period.start-date' | translate"
  />
  <elcia-date-picker
    [control]="endDate"
    [label]="'product.price-period.end-date' | translate"
  />
</div>
